import React from 'react'

import { useBrandAccountId } from '../useBrandAccountId'

export const useArchivedStrategyMemosInfiniteQueryKey = () => {
  const brandAccountId = useBrandAccountId()

  return React.useMemo(
    () =>
      [
        'StrategyMemoArchiveListPage_StrategyMemos',
        { brandAccountId },
      ] as const,
    [brandAccountId],
  )
}
